import type { KinnserClinicDataResponse } from '../../services/api/types.gen';
import { useKinnserClinicDataShared } from './useKinnserClinicDataShared';

interface UseSchedulingClinicDataOptions {
  agencySystemName: string | undefined;
  kinnserClinicId: string | null | undefined;
}

interface UseSchedulingClinicDataReturn {
  clinicData: KinnserClinicDataResponse | null;
  loadingClinicData: boolean;
}

/**
 * Simplified hook for fetching Kinnser clinic data for scheduling step.
 * Uses the shared global cache to prevent duplicate API calls.
 */
export function useSchedulingClinicData({
  agencySystemName,
  kinnserClinicId,
}: UseSchedulingClinicDataOptions): UseSchedulingClinicDataReturn {
  const { clinicData, loadingClinicData } = useKinnserClinicDataShared({
    agencySystemName,
    kinnserClinicId,
  });

  return {
    clinicData,
    loadingClinicData,
  };
}
